<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd" >新建</a-button>
    </div>

    <a-table
      ref="table"
      size="default"
      :columns="columns"
      :dataSource="dataList"
      :pagination="false"
    >
      <span slot="name" slot-scope="name,record">
         {{record.name}}  <span class="gray" v-if="record.is_default"> (默认)</span>
      </span>
      <span slot="action" slot-scope="text, record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" v-if="!record.is_default" />
          <a-popconfirm v-if="!record.is_default"  title="删除后不可恢复" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </a-table>

    <a-modal
            title="操作"
            :width="800"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="名称"
                  hasFeedback
          >
            <a-input v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入等级名称' }]}
        ]"
                     placeholder="请输入等级名称"/>
          </a-form-item>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import moment from 'moment'

  import { getSellerGroupList,editSellerGroup,addSellerGroup,deleteSellerGroup,getSellerGroupDetail } from '@/api/businessSellerGroup'
  export default {
    name: 'BusinessSellerGroupList',
    components: {
      AInput,
      ATextarea,
      STable
    },
    data () {
      return {
        visible: false,
        areaVisible: false,
        saveLoading:false,
//        description: '全校班级管理。',
        formData:{
          name:'',
          score_egt:'',
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
        },
        groupOptions:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            table: '操作',
            dataIndex: 'action',
            width: '150px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        selectedRowKeys: [],
        selectedRows: [],
        dataList:[],
      }
    },
    computed:{
    },
    created () {
    },
    mounted(){
      let self = this;
      self.fetch();
    },
    methods: {
      fetch(){
        let self =this;
        getSellerGroupList()
                .then(res => {
                  self.dataList = res.data;
                })
      },
      handleCancel(){
        this.visible = false
      },
     // 增
    handleAdd() {
      this.visible = true
      this.form.resetFields();
      this.formData = {
        id:0,
        name:'',
        score_egt:'',
      }
    },
    // 改
    handleEdit(record) {
      let self = this
      getSellerGroupDetail({ id: record.id }).then(res => {
        self.form.setFieldsValue({ ...res.data })
        self.formData.id = record.id;
        self.formData.name = res.data.name;
        self.formData.score_egt = res.data.score_egt;
      }).catch(err=>{
        self.$message.error(err.data.msg);
      })
      // console.log(this.mdl)
      this.visible = true
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          if(self.formData.id) {
            editSellerGroup(Object.assign(self.formData,values)).then(res => {
              self.$message.success('修改成功')
              self.fetch();
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }else{
            addSellerGroup(Object.assign(self.formData,values)).then(res => {
              self.$message.success('新增成功')
              self.fetch();
              self.visible = false
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        }
      })
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(true)
    },
     // 删
      deleteHandle(record) {
        let self = this
        deleteSellerGroup({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.fetch();
      }).catch(err =>{
          self.$message.error(err.data.msg)
        })
    },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
    },
    watch: {
      /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
    }
  }
</script>